module.exports = __webpack_public_path__ + "img/2.d6ef013b.png";